import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { ClaseSchema, ClasesListSchema } from '@/data/dto/clase';
export const clasesApi = {
    async listar(filtros) {
        const res = await apiClient.get(ENDPOINTS.clases, {
            params: {
                fecha: filtros.fecha,
                sucursalId: filtros.sucursalId,
                asignado: filtros.asignado,
            },
        });
        return ClasesListSchema.parse(res.data).items;
    },
    async misClases(desde, hasta) {
        const res = await apiClient.get(ENDPOINTS.misClases, { params: { desde, hasta } });
        return ClasesListSchema.parse(res.data).items;
    },
    async ver(id) {
        const res = await apiClient.get(`${ENDPOINTS.clases}/${id}`);
        return ClaseSchema.parse(res.data);
    },
    async editar(id, datos) {
        const res = await apiClient.patch(`${ENDPOINTS.clases}/${id}`, {
            fechaHoraInicio: datos.fechaHoraInicio ?? null,
            duracionHoras: datos.duracionHoras ?? null,
            disciplinaId: datos.disciplinaId ?? null,
        });
        return ClaseSchema.parse(res.data);
    },
    async asignarEmpleado(id, empleadoId, motivo) {
        const res = await apiClient.post(`${ENDPOINTS.clases}/${id}/asignar-empleado`, {
            empleadoId,
            motivo: motivo ?? null,
        });
        return ClaseSchema.parse(res.data);
    },
    async cambiarEmpleado(id, empleadoId, motivo) {
        const res = await apiClient.post(`${ENDPOINTS.clases}/${id}/cambiar-empleado`, {
            empleadoId,
            motivo: motivo ?? null,
        });
        return ClaseSchema.parse(res.data);
    },
    async desasignarEmpleado(id, motivo) {
        const res = await apiClient.post(`${ENDPOINTS.clases}/${id}/desasignar-empleado`, {
            motivo: motivo ?? null,
        });
        return ClaseSchema.parse(res.data);
    },
    async marcarDictada(id) {
        const res = await apiClient.post(`${ENDPOINTS.clases}/${id}/dictada`);
        return ClaseSchema.parse(res.data);
    },
    async cancelar(id, motivo) {
        const res = await apiClient.post(`${ENDPOINTS.clases}/${id}/cancelar`, {
            motivo: motivo ?? null,
        });
        return ClaseSchema.parse(res.data);
    },
    async aplicarPrecioOverride(id, datos) {
        const res = await apiClient.patch(`${ENDPOINTS.clases}/${id}/precio-override`, { monto: datos.monto, motivo: datos.motivo }, { headers: { 'X-Step-Up-Token': datos.stepUpToken } });
        return ClaseSchema.parse(res.data);
    },
};
